// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","light-grey":"#d4d4d4","background-grey":"#f6f6f6","white":"#ffffff","black":"#000000","toggle":"_3H8zpm4-Xf8CCvCZyyXYUH","wrapper":"OrO83kyWM8JrDJdid_MGL","left":"_36N3fMXZQHk2z1jm_RPsyO","center":"_2_DgERyTS0bM8UxoQ896db","right":"_1RBkl43IIqMGV0qNQNh-hN","hoverLeft":"_2DLE3SEHV-LBEPsNCtG483","hoverRight":"_2PE7O63KTK_04SDy5AVyZ","active":"_37G8t74w-Rm8AHL1ycVnRm","whiteBg":"_1vlD6tf0rcPHDEOMUGGXWM"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tags/FiltersTag/ToggleTag/ToggleTag.css
// module id = 1173
// module chunks = 0